<template>
    <div class="green-line-bottom"></div>
    <div class="container">
        <p class="small">© {{year}} Avtoprevozništvo Jože Topler s.p.</p>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data: () => ({
          year: ''
        }),
        methods: {
          printYear: function () {
            return new Date().getFullYear();
          }
        },
        mounted: function () {
          this.year = this.printYear();
        },
    };
</script>